/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import { useHistory, useLocation } from "react-router-dom";
import assets from "assets";
import { SecurityPageProps } from "models/security";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import useApi, { ApiMethod, IResponseUseApi } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { showMessage } from "utils/messages";
import { ResponseAdagaPinPad, msgFeedbacks } from "./model/ModelResponseAdaga";
import { LOCAL_STORE_ID_LOJA } from "../../../../../constants";
import { addPinpadResponse, selectAntecipationList } from "redux/features/cliente/cliente-slice";
import { useSelector } from "react-redux";

const FeedbackPinpad: React.FC<SecurityPageProps> = ({
  title,
  description = "",
}) => {
  const [pinpadResponse, setPinpadResponse] = useState<ResponseAdagaPinPad>();
  const [msgFeedback, setMsgFeedback] = useState(msgFeedbacks.init);
  const history = useHistory();
  const { state } = useLocation<any>();
  const { installmentPaymentInvoice } = state;

  const {
    cliente: {
      valuePaymentInvoice,
      paymentInvoice,
      invoiceInstallmentCalculation,
      valueAntecipationPurchase,
    },
  } = useAppSelector((state) => state.cliente);

  const antecipationList = useSelector(selectAntecipationList) || [];

  const { typeFlow, idLoja } = useAppSelector((state) => state.security);
  const idLojaStorge = localStorage.getItem(LOCAL_STORE_ID_LOJA);
  const storeID = idLoja || idLojaStorge;
  const dispatch = useAppDispatch();

  const valorTaxaServico =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.valorTaxaServico;

  const valorTaxaJuros =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.detalhesParcelas[
          Number(installmentPaymentInvoice) - 1
        ]?.valorTaxaJuros;

  const taxaServico =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.taxaServico;

  const taxaJuros =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.taxaJuros;

  const valorParcela =
    typeFlow === "fatura-pagamento-debito"
      ? valuePaymentInvoice || valueAntecipationPurchase
      : invoiceInstallmentCalculation?.detalhesParcelas[
          Number(installmentPaymentInvoice) - 1
        ]?.valor;

  useEffect(() => {
    if ((valuePaymentInvoice || valueAntecipationPurchase) && installmentPaymentInvoice) {
      handlePinPadStatus();
    }
  }, [valuePaymentInvoice, installmentPaymentInvoice, valueAntecipationPurchase]);

  const POSTMakePaymentInvoice = useApi(
    Endpoints.pagamentos.postMakePaymentInvoice,
    ApiMethod.POST
  );

  const GETStatusPinPadAdaga = useApi(
    Endpoints.pagamentosAdaga.getStatusPinPadAdaga,
    ApiMethod.GET
  );

  const POSTMakePaymentInvoiceAdaga = useApi(
    Endpoints.pagamentosAdaga.postMakePaymentInvoiceAdaga,
    ApiMethod.POST
  );

  const POSTLogErrorPaymentInvoice = useApi(
    Endpoints.pagamentos.postLogErrorPaymentInvoice,
    ApiMethod.POST
  );

  const clickBack = () => {
    if (pinpadResponse?.status === "approved") {
      history.push(RouteNames.ATENDIMENTO_HOME);
    } else {
      antecipationList.length > 0 ? history.push(RouteNames.ATENDIMENTO_ANTECIPACAO): history.push(RouteNames.ATENDIMENTO_FATURA);
    }
  };

  const handlePinPadStatus = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Checando Pinpad..."));
    try {
      // GETStatusPinPadAdaga
      // Verifica o status da servidor e da pinpad.
      // Caso o servidor estiver fora retorna erro.
      // Caso o servidor estiver UP retorna um "status"
      // “status": "available | running_transaction | cancelling_transaction"
      const responseStatus = await GETStatusPinPadAdaga.callApi();

      const { status } = responseStatus?.data as any;

      if (
        responseStatus.status >= 200 &&
        responseStatus.status <= 300 &&
        status === "available"
      ) {
        handlePaymentInit();
      } else {
        showMessage(
          "warning",
          "Atenção!",
          "Não houve comunicação com a maquininha de cartão (pinpad). Por favor, entre em contato com algum operador(a) da loja."
        );
        history.push(RouteNames.ATENDIMENTO_FATURA);
      }
    } catch (err) {
      console.log(err);
      showMessage(
        "warning",
        "Atenção!",
        "Não houve comunicação com a maquininha de cartão (pinpad). Por favor, entre em contato com algum operador(a) da loja."
      );
      history.push(RouteNames.ATENDIMENTO_FATURA);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handlePaymentInit = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Iniciando pagamento..."));
    try {
      // Inicia pagamento no backoffice

      const payload = {
        cpfTitular: paymentInvoice?.cliente?.cpf,
        id_fatura: paymentInvoice?.id_fatura,
        nomeTitular: paymentInvoice?.cliente?.nome,
        tipoPagamento:
          typeFlow === "fatura-pagamento-debito"
            ? "CARTAO_DEBITO"
            : "CARTAO_CREDITO",
        valorPago: Number(valuePaymentInvoice),
        origem: "TOTEM",
        idLoja: storeID,
        valorTaxaServico,
        valorTaxaJuros,
        taxaJuros,
        taxaServico,
      }
      
      const response = await POSTMakePaymentInvoice.callApi(payload);

      if (response.status >= 200 && response.status <= 300) {
        const { idPagamento, webhookPinpad } = response?.data as any;
        handlePaymentAdaga(idPagamento, webhookPinpad);
      } else {
        const { mensagem } = response.data as any;
        showMessage("warning", "Atenção!", mensagem);
        history.push(antecipationList.length > 0 ? RouteNames.ATENDIMENTO_ANTECIPACAO : RouteNames.ATENDIMENTO_FATURA);
      }
    } catch (err) {
      console.log(err);
      showMessage(
        "warning",
        "Atenção!",
        "Tente novamente mais tarde!  (Erro ao iniciar pagamento)"
      );
      history.push(RouteNames.ATENDIMENTO_FATURA);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handlePaymentAdaga = async (idPagamento: any, webhookPinpad: any) => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Siga as instruçoes na PINPAD..."));

    var response = {} as IResponseUseApi;

    try {
      // Inicia pagamento na Adaga
      const parcela = installmentPaymentInvoice
        ? Number(installmentPaymentInvoice)
        : 1;

      const valorInserido = String(
        valorParcela?.toLocaleString("pt-br", { minimumFractionDigits: 2 })
      )
        ?.replace(/[^0-9,]*/g, "")
        .replace(",", "")
        .replace(".", "");

      const payload = {
        type:
          typeFlow === "fatura-pagamento-debito" ? "debit-card" : "credit-card", // credit-card ou debit-card
        amount: Number(valorInserido) * parcela, // VALOR EM CENTAVOS
        service: "Vendas", // DEIXAR ESSE VALOR FIXO
        timeout: 120, // TIMEOUT DO PINPAD EM SEGUNDOS
        installments: parcela, // QUANTIDADE DE PARCELA [OPCIONAL]
        entryAmount: null, // VALOR DE ENTRADA [OPCIONAL]
        externalId: idPagamento, // VALOR DO IDPAGAMENTO
        urlNotification: webhookPinpad, // URL DO WEBHOOK QUER SERA CHAMADO PARA INFORMAR O STATUS DO PAGAMENTO
      };
      response = await POSTMakePaymentInvoiceAdaga.callApi(payload);

      if (response.status >= 200 && response.status <= 300) {
        setPinpadResponse(response?.data);
        const { status } = response?.data as ResponseAdagaPinPad;
        dispatch(addPinpadResponse(response?.data));

        if (status === "approved") {
          setMsgFeedback(msgFeedbacks.success);
          const propsRouter: SecurityPageProps = {
            nextStep: RouteNames.FEEDBACK_FATURA_PAGAMENTO,
            backStep: RouteNames.ESCOLHA_PAGAMENTO,
            title: `Pagar com cartão de ${
              typeFlow === "fatura-pagamento-debito" ? "débito" : "crédito"
            }`,
            description:
              "A tua fatura foi paga e o seu limite foi reestabelecido!",
          };

          history.push({
            pathname: RouteNames.FEEDBACK_FATURA_PAGAMENTO,
            state: { ...propsRouter, idPagamento },
          });
        } else if (status === "timeout") {
          setMsgFeedback(msgFeedbacks.timeout);
          showMessage("warning", "Atenção!", msgFeedbacks.timeout);
          history.push(RouteNames.ATENDIMENTO_FATURA);
        } else {
          setMsgFeedback(msgFeedbacks.failure);
          showMessage("warning", "Atenção!", msgFeedbacks.failure);
          handlePaymentLogError(response?.data, idPagamento);
          history.push(RouteNames.ATENDIMENTO_FATURA);
        }
      } else {
        setMsgFeedback(msgFeedbacks.notWork);
        showMessage("warning", "Atenção!", msgFeedbacks.notWork);
        handlePaymentLogError(response?.data, idPagamento);
        history.push(RouteNames.ATENDIMENTO_FATURA);
      }
    } catch (err) {
      setMsgFeedback(msgFeedbacks.notWork);
      console.log(err);
      showMessage("warning", "Atenção!", msgFeedbacks.notWork);
      handlePaymentLogError(response?.data, idPagamento);
      history.push(RouteNames.ATENDIMENTO_FATURA);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handlePaymentLogError = async (
    pinPad: ResponseAdagaPinPad,
    idPagamento: any
  ) => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Salvando informações do Log de pagamento..."));

    const parcela = installmentPaymentInvoice
      ? Number(installmentPaymentInvoice)
      : 1;
    try {
      // Finaliza pagamento no backoffice
      const payload = {
        cpf: paymentInvoice?.cliente?.cpf,
        idPagamento: idPagamento,
        id_fatura: paymentInvoice?.id_fatura,
        pinPad,
        qtdParcelas: parcela,
        valorJuros: valorTaxaJuros,
        valorPagoFatura: valuePaymentInvoice || valueAntecipationPurchase,
        valorParcela,
        valorTaxaServico,
      };

      await POSTLogErrorPaymentInvoice.callApi(payload);
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <ContainerFlex>
      <St.TitleH1>{title}</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanDescription>{msgFeedback}</St.SpanDescription>
          <ContainerFlex center horizontal row>
            <St.Icon src={assets.movies.gifPinPad} alt="loading..." />
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex center horizontal row space>
        <ContainerFlex>
          {pinpadResponse?.status === "approved" && (
            <AppButton content="Voltar" outlined={true} click={clickBack} />
          )}
        </ContainerFlex>
        <ContainerFlex align="flex-end">
          {pinpadResponse?.status === "approved" && (
            <AppButton content="Continuar" outlined={true} click={clickBack} />
          )}
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default FeedbackPinpad;
